<style lang="scss" scoped>
.detail-target {
  padding-bottom: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // 左侧
  .left {
    display: flex;
    align-items: center;

    .icon {
      display: inline-block;
      width: 5px;
      height: 16px;
      background: #419fff;
    }

    .txt {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      color: #303133;
      margin-left: 12px;
    }
  }

  // 右侧
  .right {
    display: flex;
    align-items: center;
  }
}
</style>

<template>
  <div ref="container" style="height: 100%;width: 100%;">
    <!-- 表单 -->
    <div class="form" ref="form">
      <el-form style="" :model="searchForm" :inline="true" size="mini">
        <el-form-item :label="$t('suoshuzuzhi')">
          <yi_data_select type="organization" :ids.sync="searchForm.orgId"> </yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('weidu2')">
          <el-select v-model="searchForm.type" :placeholder="$t('qingxuanze')">
            <el-option :label="$t('nian')" :value="1"></el-option>
            <el-option :label="$t('yue')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="searchForm.type === 1" :label="$t('xuanzeyuefen')">
          <el-date-picker style="width: 100%" v-model="searchForm.yearMonth" type="monthrange" :range-separator="$t('zhi4')" value-format="timestamp" :start-placeholder="$t('kaishiyuefen')" :end-placeholder="$t('jieshuyuefen')"> </el-date-picker>
        </el-form-item>
        <el-form-item v-show="searchForm.type === 2" :label="$t('xuanzeriqi')">
          <yi_time_input format="yyyy-MM-dd" type="daterange" :start.sync="searchForm.startTime" :end.sync="searchForm.endTime"> </yi_time_input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData" plain>{{ $t('sousuo') }} </el-button>
          <el-button type="default" @click="resetSearch" plain style="margin-left: 10px;">
            {{ $t('chongzhi') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 效率明细 -->
    <div class="detail-target" ref="title">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t('jiadonglvmingxi') }}</span>
      </div>
      <div class="right">
        <!-- <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')" @click="exportExcel"> </el-button> -->
      </div>
    </div>
    <div class="table" ref="table">
      <el-table v-if="tableHeight > 0" :data="table.tableData" border size="mini" :max-height="tableHeight" :row-style="{ height: 42 + 'px' }" :cell-style="{ padding: 0 + 'px' }" v-loading="searchLoading" :header-cell-style="{ color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
        <el-table-column v-for="(item, index) in table.tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)" style="min-width: 250px;">
          <template slot-scope="scope">
            <span v-if="['name'].includes(item.prop)" style="color: #606266">{{ scope.row[item.prop] }}</span>
            <span v-if="!['name', 'avgOperationRatio'].includes(item.prop)">{{ scope.row.operationRatioMap[item.prop] === undefined ? '-' : (scope.row.operationRatioMap[item.prop] * 100).toFixed(2) + '%' }}</span>
            <span v-if="['avgOperationRatio'].includes(item.prop)">{{ scope.row[item.prop] === undefined ? '-' : (scope.row[item.prop] * 100).toFixed(2) + '%' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import dayjs from 'dayjs';
export default {
  name: 'web_customize_zhongshuo_report_produce_report_tab_production_operation',
  data() {
    return {
      tableHeight: 0,
      searchLoading: false,
      searchForm: {
        orgId: undefined,
        type: 2,
        startTime: undefined,
        endTime: undefined,
        yearMonth: []
      },
      // 能耗表格数据
      table: {
        tableData: [],
        tableColumn: this.defaultTableColumn
      },
      defaultTableColumn: [
        {
          label: 'shebei',
          prop: 'name'
        }
      ]
    };
  },
  created() {},
  mounted() {
    this.tableHeight = this.$refs.container.offsetHeight - this.$refs.form.offsetHeight - this.$refs.title.offsetHeight - 20;
  },
  methods: {
    // 获取数据
    getData() {
      // 初始化列
      let colums = this.utils.copy(this.defaultTableColumn);
      let dates = [];
      // 选择月份时，把时间设置到startTime和endTime
      if (this.searchForm.type === 1) {
        const timeArr = this.searchForm.yearMonth;
        console.log(timeArr);
        if (!timeArr || timeArr.length === 0) {
          return;
        }
        this.searchForm.startTime = timeArr[0];
        // 设置为月份最后一天最后时刻
        let endTime = timeArr[1];
        let endDate = new Date(endTime);
        let month = endDate.getMonth();
        endDate.setMonth(month + 1, 0);
        // 设置时间为23:59:59.999
        endDate.setHours(23, 59, 59, 999);
        this.searchForm.endTime = endDate.getTime();
        dates = this.getMonths(this.searchForm.startTime, this.searchForm.endTime);
      } else {
        dates = this.getDates(this.searchForm.startTime, this.searchForm.endTime);
      }
      if (!this.searchForm.startTime || !this.searchForm.endTime) {
        return;
      }
      for (let i = 0; i < dates.length; i++) {
        const date = dates[i];
        colums.push({
          label: date,
          prop: date
        });
      }
      // 平均稼动率列
      colums.push({
        label: 'pingjunjiadonglv',
        prop: 'avgOperationRatio'
      });
      this.table.tableColumn = colums;

      this.searchLoading = true;
      this.http
        .get('/custom/zhongshuo/equipment/statistical/production/rate', {
          params: this.searchForm
        })
        .then(res => {
          const data = res.data;
          let tableData = [];
          if (data && data.length > 0) {
            tableData = data;
          }
          this.table.tableData = tableData;
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        orgId: undefined,
        type: 2,
        startTime: undefined,
        endTime: undefined,
        yearMonth: []
      };
      this.getData();
    },

    // 获取选择的日期范围内的所有日期
    getDates(startTime, endTime) {
      const dates = [];
      let currentTimestamp = startTime;
      // 循环直到当前时间戳超过b
      while (currentTimestamp <= endTime) {
        // 使用Date对象将时间戳转换为日期
        const date = new Date(currentTimestamp);
        // 将日期添加到数组中
        dates.push(dayjs(date).format('YYYY-MM-DD'));
        // 增加一天的毫秒数（24小时 * 60分钟/小时 * 60秒/分钟 * 1000毫秒/秒）
        currentTimestamp += 1000 * 60 * 60 * 24;
      }
      return dates;
    },

    // 获取选择的日期范围内的所有月份
    getMonths(startTime, endTime) {
      const months = [];
      let currentDate = new Date(startTime);
      // 将日期设置为当前月份的第一天
      currentDate.setDate(1);
      // 清除时间部分
      currentDate.setHours(0, 0, 0, 0);
      // 循环直到当前月份的时间戳超过b
      while (currentDate.getTime() <= endTime) {
        // 将当前月份的第一天添加到数组中
        months.push(dayjs(currentDate).format('YYYY-MM'));
        // 将日期设置为下一个月的第一天
        currentDate.setMonth(currentDate.getMonth() + 1);
        // 如果超过了时间戳b，且当前日期仍在该月内，则需要包含该月的最后一天
        if (currentDate.getTime() > endTime && currentDate.getMonth() === new Date(endTime).getMonth()) {
          // 获取b所在月份的最后一天
          const endDate = new Date(endTime);
          endDate.setMonth(endDate.getMonth(), 0); // 设置日期为0，将自动变为上一个月的最后一天
          endDate.setDate(endDate.getDate() + 1); // 加一天，得到当前月份的最后一天
          months.push(dayjs(endDate).format('YYYY-MM'));
          break; // 不需要再循环了
        }
      }
      return months;
    },

    // 从嵌套对象中取值
    getValueByPath(obj, path) {
      const parts = path.split('.');
      let current = obj;
      for (let i = 0; i < parts.length; i++) {
        if (current[parts[i]] !== undefined) {
          current = current[parts[i]];
        } else {
          // 如果路径中的某一部分不存在，返回undefined
          return undefined;
        }
      }
      return current;
    }
  }
};
</script>
